module.exports = __webpack_public_path__ + "media/images/icons/twotone/folder-add-95ce18d7459dc57d0b5ab2ffeadb3215.svg";